/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import Frame from '../../../../../../../../../../shared/components/Frame';
import Pdf from '../../../../../../../../../../shared/components/Pdf';
import UnifiedReportOfFiduciaClosed from '../../../../../UnifiedReport/components/UnifiedReportOfFiduciaClosed';
import { IUnifiedReportPdf } from './interface';

class UnifiedReportPdf extends React.Component<IUnifiedReportPdf> {
  gridArea = `
    " clients fiducia"
    " total total "
    " footer footer"
  `;

  render() {
    return (
      <Pdf.Page>
        <Frame.Default
          isActive={this.props.data.isActive}
          width="740px"
          margin="auto"
          display="flex"
          justifyContent="center"
          alignItems="center">
          <UnifiedReportOfFiduciaClosed />
        </Frame.Default>
      </Pdf.Page>
    );
  }
}

export default UnifiedReportPdf;
